/**
 * Kalale Premium E-commerce & Marketplace Experience Script
 * Fully integrated with Shopify AJAX Cart and Online Store 2.0
 */

// 1. Real Shopify Cart Badge Updater
async function updateShopifyCartBadge() {
  try {
    const response = await fetch('/cart.js');
    if (response.ok) {
      const cart = await response.json();
      const totalItems = cart.item_count;

      // Update Header Cart Badge
      document.querySelectorAll('.cart-badge').forEach(badge => {
        if (totalItems > 0) {
          badge.textContent = totalItems;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });

      // Update Mobile Navigation Cart Badge
      document.querySelectorAll('.cart-badge-mobile').forEach(badge => {
        if (totalItems > 0) {
          badge.textContent = totalItems;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });
    }
  } catch (e) {
    console.error('Error fetching cart:', e);
  }
}

// 3. Shopify AJAX Add to Cart Helper
async function addProductToShopifyCart(variantId, qty = 1, buttonElement = null) {
  const originalText = buttonElement ? buttonElement.innerHTML : '';
  
  if (buttonElement) {
    buttonElement.disabled = true;
    buttonElement.innerHTML = '<span class="spinner-micro"></span> Menyimpan...';
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: Number(qty)
        }]
      })
    });

    if (response.ok) {
      updateShopifyCartBadge();
      triggerNotification('✓ Produk ditambahkan ke keranjang!');
      
      if (buttonElement) {
        buttonElement.innerHTML = '✓ Sukses';
        buttonElement.style.backgroundColor = '#2F8F5E';
        buttonElement.style.borderColor = '#2F8F5E';
        buttonElement.style.color = '#FFFFFF';
        
        setTimeout(() => {
          buttonElement.innerHTML = originalText;
          buttonElement.disabled = false;
          buttonElement.style.backgroundColor = '';
          buttonElement.style.borderColor = '';
          buttonElement.style.color = '';
        }, 1200);
      }
    } else {
      const errData = await response.json();
      triggerNotification(`❌ Gagal: ${errData.description || 'Stok tidak mencukupi'}`);
      if (buttonElement) {
        buttonElement.innerHTML = originalText;
        buttonElement.disabled = false;
      }
    }
  } catch (e) {
    console.error('AJAX Error:', e);
    triggerNotification('❌ Terjadi kesalahan pengiriman.');
    if (buttonElement) {
      buttonElement.innerHTML = originalText;
      buttonElement.disabled = false;
    }
  }
}

// 4. Toast Notification System
function triggerNotification(message) {
  let container = document.getElementById('toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = 'toast-bubble';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');

  const icon = document.createElement('span');
  icon.className = 'material-symbols-rounded';
  icon.setAttribute('aria-hidden', 'true');
  icon.textContent = 'check_circle';

  const text = document.createElement('span');
  text.textContent = String(message);

  const progress = document.createElement('div');
  progress.className = 'toast-progress';
  progress.setAttribute('aria-hidden', 'true');

  toast.append(icon, text, progress);
  container.appendChild(toast);

  // Fade in, hold, fade out, destroy
  requestAnimationFrame(() => {
    toast.classList.add('is-visible');
    setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.addEventListener('transitionend', () => toast.remove());
    }, 2500);
  });
}

// 5. Flash Sale Countdown Timer
function initFlashSaleTimer() {
  const timerElement = document.querySelector('[data-flash-sale-timer]');
  if (!timerElement || timerElement.dataset.timerInitialized === 'true') return;
  timerElement.dataset.timerInitialized = 'true';

  function updateTimer() {
    const now = new Date();
    const target = new Date();
    target.setHours(23, 59, 59, 999);

    const diff = target - now;
    if (diff <= 0) {
      target.setDate(target.getDate() + 1);
    }

    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    const pad = (num) => String(num).padStart(2, '0');

    timerElement.innerHTML = `
      <span class="timer-segment">${pad(hours)}</span>
      <span class="timer-divider">:</span>
      <span class="timer-segment">${pad(minutes)}</span>
      <span class="timer-divider">:</span>
      <span class="timer-segment">${pad(seconds)}</span>
    `;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

// 6. Premium Homepage Carousel Banners
function initHomepageCarousel() {
  const container = document.querySelector('[data-carousel-banner]');
  if (!container || container.dataset.carouselInitialized === 'true') return;
  container.dataset.carouselInitialized = 'true';

  const slides = container.querySelectorAll('.carousel-slide');
  const dotsContainer = container.querySelector('.carousel-dots');
  const prevBtn = container.querySelector('.carousel-control--prev');
  const nextBtn = container.querySelector('.carousel-control--next');
  if (slides.length === 0) return;

  let current = 0;
  let timer = null;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplayEnabled = container.dataset.autoplayEnabled !== 'false' && !prefersReducedMotion && slides.length > 1;

  // Build bullets dynamically
  dotsContainer.innerHTML = Array.from({ length: slides.length }, (_, i) => {
    return `<button class="carousel-dot ${i === 0 ? 'is-active' : ''}" data-slide="${i}" aria-label="Go to banner ${i + 1}"></button>`;
  }).join('');

  const dots = dotsContainer.querySelectorAll('.carousel-dot');

  const goToSlide = (idx) => {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');

    current = (idx + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
  };

  const autoplaySpeed = container.dataset.autoplaySpeed ? Number(container.dataset.autoplaySpeed) : 4500;

  const startAutoPlay = () => {
    if (!autoplayEnabled || timer !== null) return;
    timer = setInterval(() => {
      goToSlide(current + 1);
    }, autoplaySpeed);
  };

  const resetAutoPlay = () => {
    clearInterval(timer);
    timer = null;
    startAutoPlay();
  };

  const pauseAutoPlay = () => {
    clearInterval(timer);
    timer = null;
  };

  prevBtn?.addEventListener('click', () => {
    goToSlide(current - 1);
    resetAutoPlay();
  });

  nextBtn?.addEventListener('click', () => {
    goToSlide(current + 1);
    resetAutoPlay();
  });

  dotsContainer.addEventListener('click', (e) => {
    const dot = e.target.closest('.carousel-dot');
    if (!dot) return;
    goToSlide(Number(dot.dataset.slide));
    resetAutoPlay();
  });

  container.addEventListener('pointerenter', pauseAutoPlay);
  container.addEventListener('pointerleave', startAutoPlay);
  container.addEventListener('focusin', pauseAutoPlay);
  container.addEventListener('focusout', (event) => {
    if (!container.contains(event.relatedTarget)) startAutoPlay();
  });

  startAutoPlay();
}

// 7. Shopify predictive-search suggestions. Shopify only returns products
// available to the Online Store channel, so draft or unavailable products are
// never injected into the header dropdown.
function initHeaderSearch() {
  const searchInput = document.querySelector('.search-input');
  const searchWrapper = document.querySelector('.search-bar-wrapper');
  if (!searchInput || !searchWrapper || searchWrapper.dataset.predictiveSearchEnabled !== 'true' || searchWrapper.dataset.searchInitialized === 'true') return;
  searchWrapper.dataset.searchInitialized = 'true';

  let dropdown = document.querySelector('.search-suggestions-dropdown');
  if (!dropdown) {
    dropdown = document.createElement('div');
    dropdown.className = 'search-suggestions-dropdown';
    searchWrapper.appendChild(dropdown);
  }

  let debounceTimer = null;
  let requestController = null;
  let requestSequence = 0;

  const hideSuggestions = () => {
    dropdown.replaceChildren();
    dropdown.style.display = 'none';
  };

  const appendHighlightedText = (element, text, query) => {
    const normalizedText = String(text || '');
    const normalizedQuery = query.trim();
    if (!normalizedQuery) {
      element.textContent = normalizedText;
      return;
    }

    const matcher = new RegExp(`(${normalizedQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')})`, 'gi');
    normalizedText.split(matcher).forEach((part) => {
      if (!part) return;
      if (part.toLocaleLowerCase() === normalizedQuery.toLocaleLowerCase()) {
        const highlight = document.createElement('strong');
        highlight.className = 'search-highlight';
        highlight.textContent = part;
        element.appendChild(highlight);
        return;
      }
      element.appendChild(document.createTextNode(part));
    });
  };

  const formatProductPrice = (rawPrice) => {
    const price = Number(rawPrice);
    if (!Number.isFinite(price)) return '';

    return new Intl.NumberFormat(document.documentElement.lang || 'id-ID', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'IDR',
      maximumFractionDigits: 0,
    }).format(price);
  };

  const renderEmptyState = (query) => {
    dropdown.replaceChildren();
    const emptyState = document.createElement('div');
    emptyState.className = 'search-suggest-empty';
    const icon = document.createElement('span');
    icon.className = 'material-symbols-rounded';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'search_off';
    const text = document.createElement('span');
    text.textContent = `Produk "${query}" tidak ditemukan`;
    emptyState.append(icon, text);
    dropdown.appendChild(emptyState);
    dropdown.style.display = 'block';
  };

  const renderSuggestions = (products, query) => {
    if (products.length === 0) {
      renderEmptyState(query);
      return;
    }

    dropdown.replaceChildren();
    const title = document.createElement('div');
    title.className = 'search-suggest-title';
    title.textContent = 'Rekomendasi Produk';

    const list = document.createElement('ul');
    list.className = 'search-suggest-list';

    products.forEach((product) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'search-suggest-item';
      link.href = product.url || `/products/${product.handle}`;

      // Prefer the second image when available – the first media slot is often
      // a video whose poster/thumbnail is not ideal for the search dropdown.
      const productImages = product.images;
      const secondImage = Array.isArray(productImages) && productImages.length > 1
        ? (productImages[1]?.url || productImages[1])
        : null;
      const imageUrl = secondImage || product.featured_image?.url || product.featured_image || product.image?.url || product.image;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = product.title || '';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        const imagePlaceholder = document.createElement('span');
        imagePlaceholder.className = 'search-suggest-image-placeholder material-symbols-rounded';
        imagePlaceholder.setAttribute('aria-hidden', 'true');
        imagePlaceholder.textContent = 'image';
        link.appendChild(imagePlaceholder);
      }

      const info = document.createElement('div');
      info.className = 'suggest-info';
      const name = document.createElement('span');
      name.className = 'suggest-name';
      appendHighlightedText(name, product.title, query);
      info.appendChild(name);

      const price = formatProductPrice(product.price ?? product.price_min ?? product.variants?.[0]?.price);
      if (price) {
        const priceElement = document.createElement('span');
        priceElement.className = 'suggest-price';
        priceElement.textContent = price;
        info.appendChild(priceElement);
      }

      link.appendChild(info);
      const productType = product.product_type || product.type;
      if (productType) {
        const badge = document.createElement('span');
        badge.className = 'suggest-badge';
        appendHighlightedText(badge, productType, query);
        link.appendChild(badge);
      }

      item.appendChild(link);
      list.appendChild(item);
    });

    dropdown.append(title, list);
    dropdown.style.display = 'block';
  };

  const fetchSuggestions = async (query) => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      hideSuggestions();
      return;
    }

    requestController?.abort();
    requestController = new AbortController();
    const requestId = ++requestSequence;
    const endpoint = new URL(searchWrapper.dataset.predictiveSearchUrl || '/search/suggest', window.location.origin);
    endpoint.searchParams.set('q', trimmedQuery);
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '5');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
    endpoint.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,tag');

    try {
      const response = await fetch(endpoint.toString(), {
        headers: { Accept: 'application/json' },
        signal: requestController.signal,
      });
      if (!response.ok) throw new Error(`Predictive search failed with ${response.status}`);

      const payload = await response.json();
      if (requestId !== requestSequence) return;
      const products = Array.isArray(payload?.resources?.results?.products) ? payload.resources.results.products : [];
      renderSuggestions(products, trimmedQuery);
    } catch (error) {
      if (error.name === 'AbortError' || requestId !== requestSequence) return;
      console.error('Predictive search failed.', error);
      renderEmptyState(trimmedQuery);
    }
  };

  searchInput.addEventListener('input', (event) => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => fetchSuggestions(event.target.value), 200);
  });

  searchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hideSuggestions();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.search-bar-wrapper')) hideSuggestions();
  });

  document.querySelectorAll('.search-tags a').forEach((tag) => {
    tag.addEventListener('click', (event) => {
      event.preventDefault();
      const query = tag.textContent.trim();
      searchInput.value = query;
      searchInput.focus();
      fetchSuggestions(query);
    });
  });
}

// 8. Dynamic quick buy listeners for product cards
function initQuickCartAdds() {
  if (document.documentElement.dataset.quickCartInitialized === 'true') return;
  document.documentElement.dataset.quickCartInitialized = 'true';
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.closest('[data-product-form-container]') || btn.closest('.quick-buy-modal')) return;

    // If product has multiple variants, open variant selection popup first
    if (btn.dataset.hasVariants === 'true') {
      e.preventDefault();
      openQuickBuyVariantModal(btn);
      return;
    }

    const variantId = btn.dataset.addToCart;
    if (!/^\d+$/.test(variantId || '')) return;

    e.preventDefault();
    addProductToShopifyCart(variantId, 1, btn);
  });
}

// 8a. Quick Buy Variant Selection Modal Engine
let quickBuyActiveProduct = null;
let quickBuySelectedVariant = null;
let quickBuySelectedOptions = [];
let quickBuyQuantity = 1;

function initQuickBuyModal() {
  const modal = document.getElementById('QuickBuyModal');
  if (!modal || modal.dataset.initialized === 'true') return;
  modal.dataset.initialized = 'true';

  const closeBtns = modal.querySelectorAll('[data-quick-buy-close]');
  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeQuickBuyModal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeQuickBuyModal();
    }
  });

  const qtyInput = modal.querySelector('[data-quick-buy-qty-input]');
  const minusBtn = modal.querySelector('[data-quick-buy-qty-minus]');
  const plusBtn = modal.querySelector('[data-quick-buy-qty-plus]');

  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        val -= 1;
        qtyInput.value = val;
        quickBuyQuantity = val;
      }
      minusBtn.disabled = val <= 1;
    });

    plusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < 99) {
        val += 1;
        qtyInput.value = val;
        quickBuyQuantity = val;
      }
      minusBtn.disabled = val <= 1;
    });

    qtyInput.addEventListener('change', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < 1) val = 1;
      if (val > 99) val = 99;
      qtyInput.value = val;
      quickBuyQuantity = val;
      minusBtn.disabled = val <= 1;
    });
  }

  const submitBtn = modal.querySelector('[data-quick-buy-submit]');
  if (submitBtn) {
    submitBtn.addEventListener('click', async () => {
      if (!quickBuySelectedVariant || !quickBuySelectedVariant.available) return;
      await addProductToShopifyCart(quickBuySelectedVariant.id, quickBuyQuantity, submitBtn);
      setTimeout(closeQuickBuyModal, 600);
    });
  }
}

function closeQuickBuyModal() {
  const modal = document.getElementById('QuickBuyModal');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

async function openQuickBuyVariantModal(triggerBtn) {
  const card = triggerBtn.closest('[data-product-id]') || triggerBtn.closest('.product-card') || triggerBtn.closest('.flash-sale-item');
  if (!card) return;

  let productData = null;
  const scriptTag = card.querySelector('[data-product-card-json]');
  if (scriptTag) {
    try {
      productData = JSON.parse(scriptTag.textContent);
    } catch (err) {
      console.error('Error parsing embedded product JSON:', err);
    }
  }

  if (!productData) {
    const productUrl = card.querySelector('a')?.getAttribute('href') || '';
    const match = productUrl.match(/\/products\/([^/?#]+)/);
    if (match) {
      try {
        const res = await fetch(`/products/${match[1]}.js`);
        if (res.ok) {
          const raw = await res.json();
          productData = {
            id: raw.id,
            title: raw.title,
            url: raw.url,
            featured_image: raw.featured_image,
            options: (raw.options || []).map((opt, idx) => ({
              name: typeof opt === 'object' ? opt.name : opt,
              position: idx + 1,
              values: typeof opt === 'object' ? opt.values : [...new Set((raw.variants || []).map(v => v.options[idx]))]
            })),
            variants: (raw.variants || []).map(v => ({
              id: v.id,
              title: v.title,
              available: v.available,
              price: v.price,
              price_formatted: 'Rp ' + (v.price / 100).toLocaleString('id-ID'),
              compare_at_price: v.compare_at_price,
              compare_at_price_formatted: v.compare_at_price ? 'Rp ' + (v.compare_at_price / 100).toLocaleString('id-ID') : '',
              options: v.options,
              image: v.featured_image ? v.featured_image.src : raw.featured_image
            }))
          };
        }
      } catch (e) {
        console.error('Failed to fetch product data fallback:', e);
      }
    }
  }

  if (!productData) return;

  renderQuickBuyModal(productData);
}

function renderQuickBuyModal(productData) {
  const modal = document.getElementById('QuickBuyModal');
  if (!modal) return;

  quickBuyActiveProduct = productData;
  quickBuyQuantity = 1;

  // Find initial variant (first available or first)
  const initialVariant = productData.variants.find(v => v.available) || productData.variants[0];
  quickBuySelectedVariant = initialVariant;
  quickBuySelectedOptions = initialVariant ? [...initialVariant.options] : [];

  // Populate Header
  const titleEl = modal.querySelector('[data-quick-buy-title]');
  if (titleEl) titleEl.textContent = productData.title;

  const imgEl = modal.querySelector('[data-quick-buy-image]');
  if (imgEl) {
    let imgSrc = (initialVariant && initialVariant.image) || productData.featured_image || '';
    if (imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
    imgEl.src = imgSrc;
    imgEl.alt = productData.title;
  }

  // Populate Options
  const optionsContainer = modal.querySelector('[data-quick-buy-options]');
  if (optionsContainer) {
    optionsContainer.innerHTML = '';
    (productData.options || []).forEach((option, optIdx) => {
      const groupEl = document.createElement('div');
      groupEl.className = 'quick-buy-option-group';
      groupEl.dataset.optionIndex = String(optIdx);

      const labelEl = document.createElement('div');
      labelEl.className = 'quick-buy-option-label';
      labelEl.innerHTML = `<span>${option.name}:</span> <span class="quick-buy-option-current" data-current-label>${quickBuySelectedOptions[optIdx] || ''}</span>`;
      groupEl.appendChild(labelEl);

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'quick-buy-option-values';

      (option.values || []).forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `variant-pill-button ${val === quickBuySelectedOptions[optIdx] ? 'is-active' : ''}`;
        btn.textContent = val;
        btn.dataset.value = val;
        btn.dataset.optionIndex = String(optIdx);

        btn.addEventListener('click', () => {
          quickBuySelectedOptions[optIdx] = val;
          // Update active states
          valuesWrap.querySelectorAll('.variant-pill-button').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const currentLabel = groupEl.querySelector('[data-current-label]');
          if (currentLabel) currentLabel.textContent = val;

          // Find matching variant and update prices / availability
          updateQuickBuyModalState();
        });

        valuesWrap.appendChild(btn);
      });

      groupEl.appendChild(valuesWrap);
      optionsContainer.appendChild(groupEl);
    });
  }

  // Reset Quantity
  const qtyInput = modal.querySelector('[data-quick-buy-qty-input]');
  const minusBtn = modal.querySelector('[data-quick-buy-qty-minus]');
  if (qtyInput) qtyInput.value = 1;
  if (minusBtn) minusBtn.disabled = true;

  updateQuickBuyModalState();

  // Show Modal
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function updateQuickBuyModalState() {
  const modal = document.getElementById('QuickBuyModal');
  if (!modal || !quickBuyActiveProduct) return;

  const match = quickBuyActiveProduct.variants.find((v) => {
    return v.options.every((optVal, idx) => optVal === quickBuySelectedOptions[idx]);
  });

  quickBuySelectedVariant = match;

  const priceEl = modal.querySelector('[data-quick-buy-price]');
  const comparePriceEl = modal.querySelector('[data-quick-buy-compare-price]');
  const discountEl = modal.querySelector('[data-quick-buy-discount]');
  const stockEl = modal.querySelector('[data-quick-buy-stock]');
  const stockTextEl = modal.querySelector('[data-quick-buy-stock-text]');
  const stockIcon = modal.querySelector('.quick-buy-stock-icon');
  const submitBtn = modal.querySelector('[data-quick-buy-submit]');
  const submitText = modal.querySelector('[data-quick-buy-submit-text]');
  const imgEl = modal.querySelector('[data-quick-buy-image]');

  if (match) {
    if (priceEl) priceEl.textContent = match.price_formatted || ('Rp ' + match.price.toLocaleString('id-ID'));
    if (comparePriceEl) {
      if (match.compare_at_price > match.price) {
        comparePriceEl.textContent = match.compare_at_price_formatted || ('Rp ' + match.compare_at_price.toLocaleString('id-ID'));
        comparePriceEl.style.display = 'inline';
        if (discountEl) {
          const discountPct = Math.round(((match.compare_at_price - match.price) * 100) / match.compare_at_price);
          discountEl.textContent = `-${discountPct}%`;
          discountEl.hidden = false;
        }
      } else {
        comparePriceEl.style.display = 'none';
        if (discountEl) discountEl.hidden = true;
      }
    }

    if (imgEl && match.image) {
      let mImg = match.image;
      if (mImg.startsWith('//')) mImg = 'https:' + mImg;
      imgEl.src = mImg;
    }

    if (match.available) {
      if (stockEl) stockEl.classList.remove('is-out-of-stock');
      if (stockIcon) stockIcon.textContent = 'check_circle';
      if (stockTextEl) stockTextEl.textContent = 'Tersedia';
      if (submitBtn) submitBtn.disabled = false;
      if (submitText) submitText.textContent = 'Tambah ke Keranjang';
    } else {
      if (stockEl) stockEl.classList.add('is-out-of-stock');
      if (stockIcon) stockIcon.textContent = 'cancel';
      if (stockTextEl) stockTextEl.textContent = 'Stok Habis';
      if (submitBtn) submitBtn.disabled = true;
      if (submitText) submitText.textContent = 'Stok Habis';
    }
  } else {
    if (stockEl) stockEl.classList.add('is-out-of-stock');
    if (stockIcon) stockIcon.textContent = 'info';
    if (stockTextEl) stockTextEl.textContent = 'Varian Tidak Tersedia';
    if (submitBtn) submitBtn.disabled = true;
    if (submitText) submitText.textContent = 'Varian Tidak Tersedia';
  }
}

// 8b. Header Scrolled Class Toggle
function initHeaderScrollEffect() {
  const header = document.querySelector('.site-header');
  if (!header || header.dataset.scrollInitialized === 'true') return;
  header.dataset.scrollInitialized = 'true';
  const handleScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }
  };
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

// 8c. Mobile Hamburger Menu Drawer Engine
function initMobileMenuDrawer() {
  const trigger = document.querySelector('.mobile-menu-trigger');
  const drawer = document.getElementById('MenuDrawer');
  if (!trigger || !drawer || drawer.dataset.menuInitialized === 'true') return;
  drawer.dataset.menuInitialized = 'true';

  const closeBtn = drawer.querySelector('.menu-drawer-close');
  const overlay = drawer;
  let previouslyFocusedElement = null;

  const openDrawer = () => {
    previouslyFocusedElement = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (previouslyFocusedElement instanceof HTMLElement) previouslyFocusedElement.focus();
  };

  trigger.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Handle mobile drawer sub-menus toggle
  const toggleSubmenuBtns = drawer.querySelectorAll('.menu-drawer-toggle-submenu');
  toggleSubmenuBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.menu-drawer-item--has-submenu');
      if (item) {
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        const icon = btn.querySelector('.material-symbols-rounded');
        if (icon) {
          icon.textContent = !isOpen ? 'expand_less' : 'expand_more';
        }
      }
    });
  });
}

// 8d. Mobile Collapsible Footer Menus Engine
function initFooterAccordion() {
  if (document.documentElement.dataset.footerAccordionInitialized === 'true') return;
  document.documentElement.dataset.footerAccordionInitialized = 'true';
  const toggleColumn = (toggle) => {
    if (window.innerWidth > 768) return;
    const col = toggle.closest('.footer-nav-col');
    if (!col) return;
    
    const isOpen = col.classList.contains('is-open');
    
    // Close other columns to behave as accordion
    document.querySelectorAll('.footer-nav-col').forEach(c => {
      if (c !== col) {
        c.classList.remove('is-open');
        c.querySelector('.footer-nav-toggle-wrapper')?.setAttribute('aria-expanded', 'false');
      }
    });

    col.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.footer-nav-toggle-wrapper');
    if (toggle) toggleColumn(toggle);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const toggle = event.target.closest('.footer-nav-toggle-wrapper');
    if (!toggle) return;
    event.preventDefault();
    toggleColumn(toggle);
  });
}

// 9. Initial Booting Functions
const initializeThemeSections = () => {
  updateShopifyCartBadge();
  initHomepageCarousel();
  initHeaderSearch();
  initFlashSaleTimer();
  initQuickCartAdds();
  initQuickBuyModal();
  initHeaderScrollEffect();
  initMobileMenuDrawer();
  initFooterAccordion();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeThemeSections, { once: true });
} else {
  initializeThemeSections();
}

document.addEventListener('shopify:section:load', initializeThemeSections);
